import { useCookie } from 'nuxt/app'
import { TUser, getMe } from 'features/user'
import { useUserStore } from '~/store'
import { EMarket } from '~/constants/enum'

export default defineNuxtRouteMiddleware(async () => {
  const cookieMarket = useCookie('market')
  const userStore = useUserStore()

  const { $cookieService } = useNuxtApp()
  const tokenServer = useCookie($cookieService.tokenName)
  // @ts-ignore
  if (tokenServer.value) {
    const { data } = await getMe()
    userStore.$state = (data.value?.data as unknown) as TUser
  }
  console.log(cookieMarket.value, "cookieMarket.value")
  userStore.updateMarket(cookieMarket.value ? cookieMarket.value as EMarket : EMarket.VietNam)
})
